module.exports = {
  en: "English",
  es: "Español",
};
